import React from 'react';
import { getCountryFlag } from '../../../shared/countryFlag';

// Renders country flag emojis from a list of country NAMES (the API returns
// names; we map to flags here). Falls back to the name when no flag is known.

export interface FlagsProps {
  countries: string[];
  max?: number;
}

const Flags: React.FC<FlagsProps> = ({ countries, max = 5 }) => {
  if (!countries || countries.length === 0) return null;
  const shown = countries.slice(0, max);
  const extra = countries.length - shown.length;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: 15 }}>
      {shown.map((country) => {
        const flag = getCountryFlag(country);
        return (
          <span key={country} title={country}>
            {flag || <span style={{ fontSize: 11, color: '#6c7872' }}>{country}</span>}
          </span>
        );
      })}
      {extra > 0 && <span style={{ fontSize: 11, color: '#6c7872' }}>+{extra}</span>}
    </span>
  );
};

export default Flags;
